
import Vue from 'vue'
import { newSearch } from '../store/actions';

interface SearchFormData {
	newQuery: string,
}

interface SearchFormMethods {
	submitForm(): void,
}

interface SearchFormComputed {
	query: string,
}


export default Vue.extend<SearchFormData, SearchFormMethods, SearchFormComputed, {}>({
	name: 'SearchForm',
	methods: {
		submitForm() {
			this.$store.commit({
				type: 'setQuery',
				payload: this.newQuery,
			});
			this.$store.dispatch(newSearch(null))
		}
	},
	computed: {
		query() {
			return this.$store.state.query;
		}
	}
})
